module.exports = __webpack_public_path__ + "img/governance-banner6.dbb367d0.png";